import Http from 'axios'
const BASE_URL = 'live/api/v1/examination'
const BASE_URL2 ='live/api/v1/examination/enterprise'
const axios = Http.create()
import configInterceptor from '@/service/interceptor'
configInterceptor(axios)
export default {
  // 基本信息 companyBaseInfo
  // 工商信息 businessInformation
  // 工商变更 changeRecord
  // 高管信息 executive
  // 投资信息 investment
  // 股东信息 shareholder

  reportRequestBaseInfo (path, params) {
    return axios.get(`${BASE_URL}/base/${path}`, {
      params
    })
  },

  // -----------知识产权------------
  // 商标 trademark
  // 著作权 copyright
  // 专利 patent
  // 网站备案 icp
  // -----------涉诉风险------------
  // 被执行信息 execute
  // 法律诉讼 lawSuit
  // 开庭公告 openNotice
  // 失信人信息 dishonest
  // 司法协助 judicial
  // -----------公司经营------------
  // 经营异常 abnormal
  // 行政处罚 punishment
  // 股权出质 equity
  // 动产抵押 mortgage
  // 欠税公告 ownTax
  // 严重违法 illegal
  // 行政许可证 license
  // 业务资质 certificate
  // 业务资质过期 certificateMissing

  // -------------------------------
  // 获取企业问卷的题目答案 1：公司治理，2：公司经营风险，3：劳动人事，4：知识产权 queryQA

  // 基础方法
  reportRequestInfo (path, companyId, params) {
    return axios.get(`${BASE_URL2}/${path}/${companyId}`, {
      params
    })
  },
  // 解析数据
  parseData (res, originData, pageIndex, parseFunc) {
    let data = res.data || {}
    // 兼容
    let dataInner = ('page' in data) ? (data.page || {}) : data
    let entityCount = dataInner.entityCount || 0
    let entities = dataInner.entities || []
    if (parseFunc) {
      parseFunc(entities)
    }
    return Object.assign({}, originData, {
      total: entityCount,
      pageIndex: pageIndex,
      entities: entities,
      loading: false,
      loadFinished: true
    })
  },

  parseQAData (res) {
    let data = res.data || []
    data.forEach(item => {
      let answers = item.answer || []
      item.answer = answers.map(an => {
        return an.name
      }).join('，')
    })
    return data
  },

  // 获取概览信息的风险分析
  fetchSummaryAnalysis (companyId) {
    return axios.get(`${BASE_URL}/riskStatement/${companyId}`)
  },

  // 获取企业分析或者建议
  fetchAnalysis ({ type, kind, companyId, examinationId = 0 }) {
    return axios.get(`${BASE_URL2}/${type}/${kind}/${companyId}/${examinationId}`)
  },
  // 更改
  updateAnalysis ({ type, kind, companyId, examinationId = 0, data }) {
    return axios.put(`${BASE_URL2}/${type}/${kind}/${companyId}/${examinationId}`, data)
  },

  // 判断公司是否已经被预约
  companyBooked (companyName) {
    return axios.get(`${BASE_URL}/company/booked?companyName=${companyName}`)
  },

  // 获取word报告
  exportReport (key) {
    return axios.get(`${BASE_URL}/word/report/result/${key}`)
  },

  // 获取劳动人事word报告
  exportLaborReport (key) {
    return axios.get(`${BASE_URL2}/word/result/${key}`)
  },

  // 生成报告
  generateLawReport (params) {
    return axios.post(`${BASE_URL2}/word/report`, null, { params })
  }
}
